// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1dc0P","itemTitle":"ClientEmergencyInfo_itemTitle__3ZAE2","itemText":"ClientEmergencyInfo_itemText__MLO8P"};